<template>
  <page layoutClass="map-suggested-skills">
    <b-row class="pb-3 sticky-top bg-white shadow-sm" style="z-index: 10">
      <b-col cols="12" sm="6">
        <h3 class="m-0">Suggested Skills</h3>
        <p>(Select one or more)</p>
        <b-form-input v-model="suggestedSkillSearchTerm" placeholder="Search for skills..."></b-form-input>
      </b-col>
      <b-col cols="12" sm="6">
        <h3 class="m-0">Taxonomy</h3>
        <p>(Select one)</p>
        <b-form-input v-model="taxonomySkillSearchTerm" placeholder="Search in taxonomy"></b-form-input>
      </b-col>
    </b-row>

    <div style="background: #f8f6f8">
    <error-block v-if="null" class="mb-3" :err="null"/>
    </div>

    <b-row class="py-3" style="background: #f8f8f8">
      <b-col cols="12" md="6">
        <b-card
          v-for="skill in suggestedSkills"
          :key="skill.id"
          class="border p-2 mb-2 mt-1"
          style="cursor: pointer"
          @click="toggleSuggestedSkill(skill)"
          no-body
        >
          <span>
              <font-awesome-icon
                :style="{ color: suggestedSkillSelected(skill) ? undefined : '#cccccc' }"
                class="mr-2"
                icon="check"
              />{{ skill.name }}
          </span>
        </b-card>
      </b-col>
      <b-col cols="12" md="6">
        <b-card
          v-if="!Array.isArray(displayedTaxonomySkills) || !displayedTaxonomySkills.length"
          class="mt-1 p-5 text-center"
        >
          <p>Start searching for skills in taxonomy.</p>
          <p>or</p>
          <p>Add selected skill suggestion(s) as a new one.</p>
        </b-card>
        <template v-else>
          <b-card
            v-for="skill in displayedTaxonomySkills"
            :key="skill.id"
            style="cursor: pointer"
            class="border p-2 mb-2 mt-1"
            @click="toggleTaxonomySkill(skill)"
            no-body
          >
            <span>
              <font-awesome-icon
                :style="{ color: taxonomySkillSelected(skill) ? undefined : '#cccccc' }"
                class="mr-2"
                icon="check"
              />{{ skill.name }}
            </span>
          </b-card>
        </template>
      </b-col>
    </b-row>

    <b-row class="fixed-bottom bg-white border-top">
      <b-col
        cols="12" md="6"
        class="border-right py-3 px-0 d-flex flex-row-reverse justify-content-between align-items-center"
      >
        <b-button
          variant="outline-danger"
          class="mr-3"
          size="sm"
          :disabled="!Array.isArray(selectedSuggestedSkills) || !selectedSuggestedSkills.length"
          v-b-modal.delete-skill-modal
        >Delete Selected</b-button>
        <b-link
          v-if="Array.isArray(selectedSuggestedSkills) && selectedSuggestedSkills.length"
          variant="primary"
          class="ml-4"
          size="sm"
          v-b-modal.selected-suggested-skills-modal
        >See Selected ({{ selectedSuggestedSkills.length }})</b-link>
      </b-col>
      <b-col
        cols="12" md="6"
        class="py-3 pl-0 pr-3 d-flex flex-row-reverse justify-content-between align-items-center"
      >
        <b-button
          v-show="selectedTaxonomySkill"
          variant="primary"
          class="mr-3"
          size="sm"
          :disabled="!Array.isArray(selectedSuggestedSkills) || !selectedSuggestedSkills.length"
          v-b-modal.map-skill-modal
        >Map Selected</b-button>
        <b-button
          v-show="!selectedTaxonomySkill"
          variant="primary"
          class="mr-3"
          size="sm"
          :disabled="!Array.isArray(selectedSuggestedSkills) || !selectedSuggestedSkills.length"
          v-b-modal.add-new-skill-modal
        >Add New Skill</b-button>
        <b-link
          v-if="selectedTaxonomySkill"
          variant="primary"
          class="ml-3"
          size="sm"
          v-b-modal.selected-taxonomy-skill-modal
        >See Selected</b-link>
      </b-col>
    </b-row>

    <!-- Selected Suggested Skills Modal -->
    <b-modal
      id="selected-suggested-skills-modal"
      title="Edit Selected Suggestions"
      body-class="gray-bg"
      hide-footer
      lazy
    >
      <template v-if="Array.isArray(selectedSuggestedSkills) && selectedSuggestedSkills.length">
        <b-card
            v-for="skill in selectedSuggestedSkills"
            :key="skill.id"
            class="border p-2 mb-2 mt-1"
            style="cursor: pointer"
            @click="toggleSuggestedSkill(skill)"
            no-body
          >
            <span>
                <font-awesome-icon
                  :style="{ color: suggestedSkillSelected(skill) ? undefined : '#cccccc' }"
                  class="mr-2"
                  icon="check"
                />{{ skill.name }}
            </span>
          </b-card>
      </template>
      <b-card v-else no-body class="p-3 text-center">
        No skill selected.
      </b-card>
    </b-modal>

    <!-- Selected Taxonomy Skill Modal -->
    <b-modal
      id="selected-taxonomy-skill-modal"
      title="Edit Selected Taxonomy"
      body-class="gray-bg"
      hide-footer
      lazy
    >
      <b-card
        v-if="selectedTaxonomySkill"
        class="border p-2 mb-2 mt-1"
        style="cursor: pointer"
        @click="toggleTaxonomySkill(selectedTaxonomySkill)"
        no-body
      >
        <span>
            <font-awesome-icon
              class="mr-2"
              icon="check"
            />{{ selectedTaxonomySkill.name }}
        </span>
      </b-card>
      <b-card v-else no-body class="p-3 text-center">
        No skill selected.
      </b-card>
    </b-modal>

    <!-- Add New Skill Modal -->
    <b-modal
      id="add-new-skill-modal"
      title="Add New Skill"
      body-class="gray-bg"
      hide-footer
    >
      <template v-if="!response.request">
        <template v-if="Array.isArray(selectedSuggestedSkills) && selectedSuggestedSkills.length && !selectedTaxonomySkill">
          <div>
            {{ selectedSuggestedSkills.map(({ name }) => name).join(', ') }} will be replaced with...
          </div>
          <div class="mt-2">
            <b-form-input v-model="newSkillName" placeholder="Type new skill name here..."></b-form-input>
          </div>
        </template>
        <div class="mt-3">
          <b-button
            variant="primary"
            size="sm"
            :disabled="!newSkillName"
            class="float-right"
            @click.prevent="mapSkillsToNewSkill()"
          >Create New Skill & Map</b-button>
        </div>
      </template>
      <template v-else-if="response.request === 'MAP_SKILLS_TO_NEW_SKILL'">
        <div v-if="response.type === 'SUCCESS_ADDING_SKILL'" class="mt-2">
          New skill is successfully added to taxonomy.
        </div>
        <div v-if="response.type === 'SUCCESS_MAPPING_SKILLS'" class="mt-2">
          Suggested skills are mapped to the new skill created.
        </div>
        <div v-if="response.type === 'ERROR'" class="mt-2">
          An error occured while mapping skills to the newly created one.
        </div>
        <div class="mt-3">
          <b-button
            variant="primary"
            size="sm"
            class="float-right"
            @hidden="response = { request: '', type: '' }"
            @click.prevent="$bvModal.hide('add-new-skill-modal')"
          >Okay</b-button>
        </div>
      </template>
    </b-modal>

    <!-- Map Skill Modal -->
    <b-modal
      id="map-skill-modal"
      title="Map Skill"
      body-class="gray-bg"
      hide-footer
    >
      <template v-if="!response.request">
        <div v-if="Array.isArray(selectedSuggestedSkills) && selectedSuggestedSkills.length && selectedTaxonomySkill">
          {{ selectedSuggestedSkills.map(({ name }) => name).join(', ') }} will be replaced with {{ selectedTaxonomySkill.name }}
        </div>
        <div class="mt-3">
          <b-button
            variant="primary"
            size="sm"
            class="float-right"
            @click.prevent="mapSkills()"
          >Map Skills</b-button>
        </div>
      </template>
      <template v-else-if="response.request === 'MAP_SKILLS'">
        <div v-if="response.type === 'SUCCESS'" class="mt-2">
          Suggested skills are mapped successfully.
        </div>
        <div v-if="response.type === 'ERROR'" class="mt-2">
          An error occured while mapping skills.
        </div>
        <div class="mt-3">
          <b-button
            variant="primary"
            size="sm"
            class="float-right"
            @hidden="response = { request: '', type: '' }"
            @click.prevent="$bvModal.hide('map-skill-modal')"
          >Okay</b-button>
        </div>
      </template>
    </b-modal>

    <!-- Delete Skill Modal -->
    <b-modal
      id="delete-skill-modal"
      title="Delete Skill"
      body-class="gray-bg"
      hide-footer
      lazy
    >
      <div>Are you sure you want to delete the following suggested skills?</div>
      <div class="mt-2">{{ selectedSuggestedSkills.map(({ name }) => name).join(', ') }}</div>
      <div class="mt-3">
        <b-button
          variant="outline-danger"
          size="sm"
          class="float-right"
          @click.prevent="() => { $bvModal.hide('delete-skill-modal'); deleteSkills() }"
        >Yes, I am</b-button>
      </div>
    </b-modal>

  </page>
</template>

<script>
import gql from 'graphql-tag';
import Page from '@/components/Page';
import enumsMixin from '@/mixins/enums';
import ErrorBlock from '@/components/misc/ErrorBlock';
import SearchTaxonomySkillsQuery from '@/graphql/queries/SearchTaxonomySkills.gql';
import SearchSuggestedSkillsQuery from '@/graphql/queries/SearchSuggestedSkills.gql';
import { mapRoot } from '@src/mixins/root';

const AddSkillsTaxonomyMutation = gql`
  mutation AddSkillsTaxonomy($create: CreateTaxonomySkillInput!) {
    createTaxonomySkills(create: $create)
  }
`;

const MapTaxonomySkills = gql`
  mutation mapTaxonomySkills($skills: [String!]!, $skill: String!) {
    mapTaxonomySkills(create: { skill: $skill, skills: $skills })
  }
`;

const DeleteTaxonomySkillSuggestions = gql`
  mutation mapTaxonomySkills($skills: [String!]!) {
    deleteTaxonomySkillSuggestions(delete: { skills: $skills })
  }
`;

export default {
  components: {
    Page,
    ErrorBlock,
  },
  mixins: [
    enumsMixin,
  ],
  data: () => ({
    suggestedSkillSearchTerm: '',
    taxonomySkillSearchTerm: '',
    selectedSuggestedSkills: [],
    selectedTaxonomySkill: null,
    newSkillName: '',
    response: {
      request: '',
      type: '',
    }
  }),
  apollo: {
    suggestedSkills: {
      query: SearchSuggestedSkillsQuery,
      variables() {
        const { suggestedSkillSearchTerm: searchTerm } = this;
        return { searchTerm };
      },
      update: ({ company: { taxonomySuggestedSkills } }) => taxonomySuggestedSkills,
      error(err) {
        this.allUsersErr = err;
      },
      fetchPolicy: 'network-only',
      deep: true,
    },
    taxonomySkills: {
      query: SearchTaxonomySkillsQuery,
      variables() {
        const { taxonomySkillSearchTerm: searchTerm } = this;
        return { searchTerm };
      },
      update({ company: { taxonomySkills } }) {
        return Array.isArray(taxonomySkills) ? taxonomySkills.reduce((out, { id, name, alternateNames }) => {
          if (!out.includes(name)) out.push({ id, name });
          if (Array.isArray(alternateNames)) {
            alternateNames.forEach(el => {
              if (!out.includes(el)) out.push({ id, name: el });
            });
          }
          return out;
        }, []).sort((a, b) => a.length - b.length) : [];
      },
      skip() {
        return !this.taxonomySkillSearchTerm || this.taxonomySkillSearchTerm.length < 2;
      },
      fetchPolicy: 'network-only',
      error(err) {
        this.$log.error(err);
      },
    },
  },
  computed: {
    ...mapRoot([ 'isRecruiterAdmin' ]),
    displayedTaxonomySkills() {
      if (!this.taxonomySkillSearchTerm || this.taxonomySkillSearchTerm.length < 2) {
        return [];
      }
      return this.taxonomySkills;
    }
  },
  methods: {
    toggleSuggestedSkill(skill) {
      const index = this.selectedSuggestedSkills.findIndex(({ id }) => id === skill.id);
      if (index === -1) {
        this.selectedSuggestedSkills.push(skill);
      } else {
        this.selectedSuggestedSkills.splice(index, 1);
      }
    },
    toggleTaxonomySkill(skill) {
      if (this.selectedTaxonomySkill && this.selectedTaxonomySkill.id === skill.id) {
        this.selectedTaxonomySkill = null;
      } else {
        this.selectedTaxonomySkill = skill;
      }
    },
    suggestedSkillSelected(skill) {
      return this.selectedSuggestedSkills.findIndex(({ id }) => id === skill.id) > -1;
    },
    taxonomySkillSelected(skill) {
      return this.selectedTaxonomySkill && this.selectedTaxonomySkill.id === skill.id;
    },
    async mapSkills() {
      try {
        await this.$apollo.mutate({
          mutation: MapTaxonomySkills,
          variables: {
            skill: this.selectedTaxonomySkill.name,
            skills: this.selectedSuggestedSkills.map(({ name }) => name),
          },
          update: store => {
            const data = store.readQuery({
              query: SearchSuggestedSkillsQuery,
              variables: { searchTerm: this.suggestedSkillSearchTerm }
            });
            data.company.taxonomySuggestedSkills = data.company.taxonomySuggestedSkills
              .filter(({ name }) => !this.selectedSuggestedSkills.map(({ name }) => name).includes(name));
            store.writeQuery({
              query: SearchSuggestedSkillsQuery,
              variables: { searchTerm: this.suggestedSkillSearchTerm },
              data
            });
          },
        });
        this.selectedSuggestedSkills = [];
        this.selectedTaxonomySkill = null;
        this.response = { request: 'MAP_SKILLS', type: 'SUCCESS' };
      } catch (error) {
        console.log(error);
        this.response = { request: 'MAP_SKILLS', type: 'ERROR' };
      }
    },
    async mapSkillsToNewSkill() {
      try {
        await this.$apollo.mutate({
          mutation: AddSkillsTaxonomyMutation,
          variables: {
            create: {
              skills: [ this.newSkillName ]
            }
          },
        });
        this.response = { request: 'MAP_SKILLS_TO_NEW_SKILL', type: 'SUCCESS_ADDING_SKILL' };
        await this.$apollo.mutate({
          mutation: MapTaxonomySkills,
          variables: {
            skill: this.newSkillName,
            skills: this.selectedSuggestedSkills.map(({ name }) => name),
          },
          update: store => {
            const data = store.readQuery({
              query: SearchSuggestedSkillsQuery,
              variables: { searchTerm: this.suggestedSkillSearchTerm }
            });
            data.company.taxonomySuggestedSkills = data.company.taxonomySuggestedSkills
              .filter(({ name }) => !this.selectedSuggestedSkills.map(({ name }) => name).includes(name));
            store.writeQuery({
              query: SearchSuggestedSkillsQuery,
              variables: { searchTerm: this.suggestedSkillSearchTerm },
              data
            });
          },
        });
        this.selectedSuggestedSkills = [];
        this.selectedTaxonomySkill = null;
        this.response = { request: 'MAP_SKILLS_TO_NEW_SKILL', type: 'SUCCESS_MAPPING_SKILLS' };
      } catch (error) {
        this.response = { request: 'MAP_SKILLS_TO_NEW_SKILL', type: 'ERROR' };
        console.log(error);
      }
    },
    async deleteSkills() {
      try {
        await this.$apollo.mutate({
          mutation: DeleteTaxonomySkillSuggestions,
          variables: {
            skills: this.selectedSuggestedSkills.map(({ name }) => name),
          },
          update: store => {
            const data = store.readQuery({
              query: SearchSuggestedSkillsQuery,
              variables: { searchTerm: this.suggestedSkillSearchTerm }
            });
            data.company.taxonomySuggestedSkills = data.company.taxonomySuggestedSkills
              .filter(({ name }) => !this.selectedSuggestedSkills.map(({ name }) => name).includes(name));
            store.writeQuery({
              query: SearchSuggestedSkillsQuery,
              variables: { searchTerm: this.suggestedSkillSearchTerm },
              data
            });
          },
        });
        this.selectedSuggestedSkills = [];
        this.selectedTaxonomySkill = null;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Recruiter/MapSuggestedSkills.vue